import * as constants from "../../assets/constants";
import {baseApi} from "../BaseApi";

class StandCollectionsApi extends baseApi {

    getOne = async (id) => {
        return await this.get(`?app=standcollections&act=getOne&id=${id}`)
    }

    getList = async (data) => {
        return await this.post('?app=standcollections&act=getList', data)
    }

    save = async (data) => {
        return await this.post('?app=standcollections&act=save', {data: JSON.stringify(data)})
    }

    delete = async (id) => {
        return await this.post('?app=standcollections&act=setDeleted', {id})
    }

    browseProductsPath = '?app=standcollections&act=browseProducts'

    browseProducts = async (data) => {
        return await this.post(this.browseProductsPath, data)
    }

    getBindingsList = async (data) => {
        return await this.post('?app=standcollections&act=getBindingsList', data)
    }

    getBindingsExportUrl = (search = '') => {
        return `${this.base_url}?app=standcollections&act=exportBindingsXlsx&search=${encodeURIComponent(search)}`
    }

    getMatchingCollections = async (data) => {
        return await this.post('?app=standcollections&act=getMatchingCollections', data)
    }

    bindProduct = async (data) => {
        return await this.post('?app=standcollections&act=bindProduct', data)
    }

    unbindProduct = async (data) => {
        return await this.post('?app=standcollections&act=unbindProduct', data)
    }

    bindGroup = async (data) => {
        return await this.post('?app=standcollections&act=bindGroup', data)
    }

    unbindGroup = async (data) => {
        return await this.post('?app=standcollections&act=unbindGroup', data)
    }
}

export default new StandCollectionsApi(constants.DEBUG ? constants.base_url_stage : constants.base_url_prod);
